/* eslint-disable react/jsx-no-useless-fragment */
import { Footer, Navbar } from '@components';
import { useProtectedRoute } from '@context/ProtectedRouteContext';
import { memo } from 'react';
import routes from '@constants/routes';
import { IDashboardLayoutProps } from './DefaultLayout.types';
import styles from './styles.module.scss';

export const DefaultLayout = memo<IDashboardLayoutProps>(({ children }) => {
  const { isProtected } = useProtectedRoute();
  if (!isProtected) return <>{children}</>;

  return (
    <div className={styles.container}>
      <Navbar routes={routes} />
      {children}
      <Footer />
    </div>
  );
});

DefaultLayout.displayName = 'DefaultLayout';

export default DefaultLayout;
